export default function Contact() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">联系我们</h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">有任何建议、影片需求或合作意向，欢迎随时与我们联系</p>
        </div>
        <div className="max-w-2xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
            <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center hover:border-primary-200 transition-all duration-300">
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-mail-line text-xl text-primary-600"></i>
              </div>
              <h3 className="font-heading text-sm text-foreground-900 mb-1">内容建议</h3>
              <p className="text-xs text-foreground-500">推荐您想看的影片，我们会尽快评估上架</p>
              <div className="mt-3 text-xs text-primary-600 font-medium">contact@blueberrycinema.com</div>
            </div>
            <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center hover:border-primary-200 transition-all duration-300">
              <div className="w-12 h-12 rounded-xl bg-accent-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-shake-hands-line text-xl text-accent-600"></i>
              </div>
              <h3 className="font-heading text-sm text-foreground-900 mb-1">商务合作</h3>
              <p className="text-xs text-foreground-500">广告投放、版权合作、品牌联合推广</p>
              <div className="mt-3 text-xs text-accent-600 font-medium">biz@blueberrycinema.com</div>
            </div>
            <div className="bg-background-50 border border-background-200/70 rounded-xl p-5 text-center hover:border-primary-200 transition-all duration-300">
              <div className="w-12 h-12 rounded-xl bg-secondary-100 flex items-center justify-center mx-auto mb-3">
                <i className="ri-bug-line text-xl text-secondary-600"></i>
              </div>
              <h3 className="font-heading text-sm text-foreground-900 mb-1">问题反馈</h3>
              <p className="text-xs text-foreground-500">播放问题、页面错误、功能建议</p>
              <div className="mt-3 text-xs text-secondary-600 font-medium">support@blueberrycinema.com</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}